<template>
  <el-row class="bread">
    <el-col :span="24" class="left-box">
      <el-breadcrumb separator="/" separator-class="el-icon-arrow-right">
        <template v-for="bread in breadList" >
          <el-breadcrumb-item :key="bread.url" :to="{ path: bread.url }" v-if="bread.url">{{bread.name}}</el-breadcrumb-item>
          <el-breadcrumb-item :key="bread.name" v-else>{{bread.name}}</el-breadcrumb-item>
        </template>
      </el-breadcrumb>
    </el-col>
    <slot></slot>
  </el-row>
</template>

<script>
export default {
  name: 'Bread',

  data() {
    return {};
  },

  props: ['breadList'],
};
</script>

<style lang="scss">
  .bread {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    .el-breadcrumb {
      font-size: 16px;
      .el-breadcrumb__item {
        .el-breadcrumb__inner {
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 130%;
          /* identical to box height, or 21px */

          text-transform: capitalize;

          color: $--color-primary;
          &.is-link{
            /* Grey */

            color: $--color-Grey;
          }
        }
        .el-breadcrumb__separator{
          /* Grey */

          color: $--color-Grey;
        }
      }
    }
    .right-box {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/v-bread.vue